import { ProgressIndicator } from '@veneer/core';
import React from 'react';
import { MediaclipEvents } from '../../helpers/mediaclipEvents';
import { DataCollection } from '../../jarvis/dataCollection';

declare global {
  interface Window {
    launchMediaclipDesigner: (projectId: string, userMediaclipToken: string, keepAliveUrl: string) => void;
  }
}

export type DesignerProps = {
  /**
   * Optional base URL for transactional backend service. If not provided, will use the default URL for the stack
   */
  projectId: string;
  userMediaclipToken: string;
  keepAliveUrl: string;
  dataCollection: DataCollection;
};

export class Designer extends React.Component<DesignerProps> {
  componentDidMount() {
    this.launchMediaclipDesigner();
  }

  componentDidUpdate() {
    this.launchMediaclipDesigner();
  }

  launchMediaclipDesigner() {
    console.log('Launching designer with project id: ' + this.props.projectId);
    if (this.props.projectId && this.props.userMediaclipToken) {
      this.addAnalyticsHandler();
      window.launchMediaclipDesigner(this.props.projectId, this.props.userMediaclipToken, this.props.keepAliveUrl);
    }
  }

  addAnalyticsHandler() {
    window.addEventListener('message', (message) => {
      if (message.origin !== 'https://mc-hub-designer-sto-use.azureedge.net') {
        console.error('Designer::addAnalyticsHandler: Unexpected message origin: %s', message.origin);
        return;
      }
      if (message.data.mediaclipDesignerAppMetricsData) {
        console.log('Designer::addAnalyticsHandler: AppMetrics received: %o', message.data);
        MediaclipEvents.sendAppMetricsData(message.data.mediaclipDesignerAppMetricsData, this.props.dataCollection);
      } else if (message.data.mediaclipDesignerHookData) {
        console.log('Designer::addAnalyticsHandler: Hook received: %o', message.data);
        MediaclipEvents.sendDesignerHookData(message.data.mediaclipDesignerHookData, this.props.dataCollection);
      } else if (message.data.mediaclipDesignerLoaded) {
        console.log('Designer::addAnalyticsHandler: Designer loaded');
        MediaclipEvents.sendScreenViewEvent(this.props.dataCollection);
      }
    });
  }

  render() {
    return (
      <div className="DesignerPage page">
        {/* <!-- Mediaclip Designer placeholder --> */}
        <div id="designer" className="mediaclip-designer-wrapper">
          <div className="linear">
            <ProgressIndicator appearance="linear" />
          </div>
          <div id="error-message"></div>
        </div>
      </div>
    );
  }
}

export default Designer;
